import { render } from "./audio.widget.vue?vue&type=template&id=7c9b5a65&scoped=true&ts=true"
import script from "./audio.widget.vue?vue&type=script&lang=ts"
export * from "./audio.widget.vue?vue&type=script&lang=ts"

import "./audio.widget.vue?vue&type=style&index=0&id=7c9b5a65&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9b5a65"]])

export default __exports__